import React from 'react'
import classnames from 'classnames'

const HeroBase = ({ children, cols, center, className }) => (
    <div
        className={classnames(
            `hero hero--main hero--gradient-blue ${
                center ? 'hero--center' : ''
            }`,
            className
        )}
    >
        <div className="hero__container container">
            <div className={cols ? 'hero__cols' : 'hero__content'}>
                {children}
            </div>
        </div>
    </div>
)

export default HeroBase



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/HeroBase.jsx